import * as React from 'react';
import { flatMap } from 'lodash';

import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { connect } from 'react-redux';
import ListContainerView from '../../views/library/list-container.view';
import { IPackageListingAppState } from '../../redux-state';

interface IListContainerExternalProps {

}

interface StateToProps {
    productionCount: number;
    minimumPackagePerformanceQuantityMessage: string;
    reachedPackageMaxQuantity: boolean;
    text: IPackageListingAppText;
    isFixed: boolean;
}

export type ListContainerProps = IListContainerExternalProps & StateToProps;

export const ListContainerBase: React.StatelessComponent<ListContainerProps> = props => {
    return (
        <ListContainerView {...props} />
    )
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListContainerExternalProps): StateToProps {
    if (state.packageListingSettings.isFixed) {
        return {
            productionCount: 0,
            minimumPackagePerformanceQuantityMessage: "",
            text: state.packageListingText,
            reachedPackageMaxQuantity: false,
            isFixed: true
        }
    } else {
        return {
            isFixed: false,
            productionCount: flatMap(state.packageListing.packageDetail.performanceGroupDetails, g => g.appProductions).length,
            minimumPackagePerformanceQuantityMessage: state.packageListing.packageDetail.minimumPerformances != null
                ? state.packageListingText.minimumPerformanceRequiredMessage.replace("{0}", state.packageListing.packageDetail.minimumPerformances.toString()) : "",
            text: state.packageListingText,
            reachedPackageMaxQuantity: state.packageListing.cartItems.size >= state.packageListing.packageDetail.maximumPerformances
        }
    }
}

export default connect(mapStateToProps)(ListContainerBase);